/*
 * @Description:
 * @Author: WangYuhan
 * @Date: 2022-09-19 10:25:05
 * @LastEditTime: 2023-01-06 14:27:59
 * @LastEditors: WangYuhan
 */
// 获取cookie
export function setCookie(val, value, domain, expire) {
  var date = new Date();
  date.setSeconds(date.getSeconds() + expire);
  document.cookie = `${val}=${escape(value)}; expires=${date.toGMTString()}; domain=${domain}`;
}
// 获取cookie
export function getCookie(val) {
  if (document.cookie.length > 0) {
    let str = document.cookie.indexOf(`${val}=`);
    if (str !== -1) {
      str = str + val.length + 1;
      let offover = document.cookie.indexOf(';', str);
      if (offover === -1) offover = document.cookie.length;
      return unescape(document.cookie.substring(str, offover));
    }
  }
  return '';
}

// 清空cookie
export function clearCookie() {
  // cloud.***/user 退出时可以全部清掉
  var keys = document.cookie.match(/[^ =;]+(?==)/g);
  if (keys) {
    for (let i = keys.length; i--; ) {
      document.cookie = `${keys[i]}=0;expires=${new Date(0).toUTCString()}`;
    }
  }
}

// 删除cookie
export function delCookie(name, domain, path) {
  if (domain !== 'localhost' && domain.indexOf('local') < 0) {
    domain = `.${domain}`;
  }
  document.cookie = `${name}=${getCookie(name)};expires=${new Date(
    1,
  )};domain=${domain};path=${path}`;
}
